// extracted by mini-css-extract-plugin
export default {"zoomControl":"style_zoomControl__+vxVG","zoomIcon":"style_zoomIcon__fa73S","zoomRange":"style_zoomRange__jiXq2","zoomButton":"style_zoomButton__sOaRZ"};